// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/portal',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------
export const buildDashboardPath = (alias: string) => `${ROOTS.DASHBOARD}/${alias}`;

export const paths = {
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/sign-in`,
      signUp: `${ROOTS.AUTH}/sign-up`,
    },
  },
  dashboard: {
    root: ROOTS.DASHBOARD,
    dashboard: buildDashboardPath,
  },
};
